import { Injectable } from '@angular/core';
import {
  type ActivatedRouteSnapshot,
  type DetachedRouteHandle,
  type RouteReuseStrategy,
} from '@angular/router';

import { RouteParam } from '../shared/common';

@Injectable({
  providedIn: 'root',
})
export class OrganizationRouteReuseStrategy implements RouteReuseStrategy {
  retrieve(): DetachedRouteHandle | null {
    return null;
  }

  shouldAttach(): boolean {
    return false;
  }

  shouldDetach(): boolean {
    return false;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    const hasSameRouteConfig = future.routeConfig === current.routeConfig;
    const hasChangedOrganizationTenantKey = this.hasChangedOrganizationTenantKey(
      future,
      current,
    );

    return hasSameRouteConfig && !hasChangedOrganizationTenantKey;
  }

  store(): void {}

  private hasChangedOrganizationTenantKey(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot,
  ): boolean {
    const futureOrganizationTenantKey = future.paramMap.get(RouteParam.OrganizationTenantKey);
    const currentOrganizationTenantKey = current.paramMap.get(RouteParam.OrganizationTenantKey);
    const hasOrganizationTenantKey = future.paramMap.has(RouteParam.OrganizationTenantKey)
      || current.paramMap.has(RouteParam.OrganizationTenantKey);

    return hasOrganizationTenantKey
      && futureOrganizationTenantKey !== currentOrganizationTenantKey;
  }
}
